/**
 * /onboarding/success — pagina post-submit completeOnboarding.
 *
 * Visualizzazione finale dopo l'invio dei dati. Niente CTA per
 * tornare al form: il token e' ormai used.
 */

import { OnboardingShell } from '../components/OnboardingShell';

export function OnboardingSuccessPage() {
  return (
    <OnboardingShell>
      <div className="text-center py-8 md:py-16">
        <div
          className="w-16 h-16 mx-auto mb-6 rounded-full bg-tertiary-container flex items-center justify-center"
          aria-hidden="true"
        >
          <span className="material-symbols-outlined text-on-tertiary-container text-3xl">
            check_circle
          </span>
        </div>
        <h1 className="text-2xl md:text-3xl font-semibold text-text-main mb-3">
          Grazie, abbiamo ricevuto i tuoi dati
        </h1>
        <p className="text-text-secondary text-base md:text-lg mb-2">
          Lo studio prendera' visione del tuo modulo e ti contattera' a breve
          per fissare la prima visita.
        </p>
        <p className="text-text-secondary text-sm md:text-base mb-6">
          Hai ricevuto anche una email di conferma all'indirizzo che ci hai
          fornito.
        </p>
        <p className="text-text-secondary text-xs md:text-sm mt-8">
          Per qualunque domanda puoi rispondere all'email di conferma.
        </p>
      </div>
    </OnboardingShell>
  );
}
